export const environment = {
  production: true,
  learningUrl: 'https://learn.tsin.ca/',
  userBaseUrl: 'https://auth.tsin.ca/api',
  userMgtUrl: 'https://portal1.tsin.ca/auth/login',
  paymentUrl: 'https://payment.tsin.ca',
  examOldUrl: 'https://portal.tsin.ca/',
  examUrl: 'https://portal.tsin.ca/',
  userBaseUrlFallback: 'https://user-prod.tsin.ca/api',
  userBaseMgtUrlFallback: 'http://user.tsin.ca/auth/login',
  apiUrl: 'https://36mtp2pnd6.us-east-1.awsapprunner.com/api',


  // paymentUrl: 'http://localhost:4400',
  examOldBaseUrl: 'https://portal-be.tsin.ca/api',
  learningBaseUrl: 'https://learn-be.tsin.ca/api',
  salt: 'ZC\f?.Kp[jnhXf3-"<f3{/tZS@#~(8on',
  paymentMode: 'prod',
  paymentTimeLimitInMs: 180000,
};
